module.exports = __webpack_public_path__ + "static/media/dp.6233f9dc.jpeg";